/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  Formatters,
  TooltipIcon,
  Tooltip,
  Body,
} from '../../coreui';

import DashboardTableCell from './DashboardTableCell';
import PendingDashboardCancelCell from './PendingDashboardCancelCell';
import HeaderComponent from './TableHeader';
import StyledTable from './StyledTable';

const columns = () => {
  return [
    {
      Header: <HeaderComponent>Investment</HeaderComponent>,
      accessor: 'investment',
      minWidth: 300,
      Cell: DashboardTableCell(),
      id: 'investmentUrl',
    },
    {
      Header: <HeaderComponent>Type</HeaderComponent>,
      accessor: 'type',
      Cell: DashboardTableCell(),
    },
    {
      Header: <HeaderComponent>Date</HeaderComponent>,
      accessor: 'date',
      show: false,
    },
    {
      minWidth: 300,
      Header: <HeaderComponent>Minimum Amount</HeaderComponent>,
      accessor: 'minAmount',
      Cell: DashboardTableCell(Formatters.DOLLARS_DECIMALS),
    },
    {
      width: 150,
      Header: <HeaderComponent justify="center">Cancel</HeaderComponent>,
      Cell: (cellProps) => (
        <PendingDashboardCancelCell
          {...cellProps}
          // When the user removes the item from their list, React needs to
          // know that this component completely changed. Otherwise, the modal
          // stays open.
          key={`pendingWaitListCancelCell:${cellProps.original.id}`}
        />
      ),
      accessor: 'cancel',
    },
  ];
};

const WaitlistInvestmentsTable = ({ investments, tooltip }) => {
  if (!investments) {
    return null;
  }

  return (
    <ExtendedFlex
      flexDirection="column"
      width={1}
      alignItems="center"
      mt={140}
    >
      <StyledTable
        title="Waitlist"
        tooltip={
          <>
            <TooltipIcon
              tooltipId="waitlistInvestmentsTooltip"
            />
            <Tooltip id="waitlistInvestmentsTooltip">
              <Body type="B5">
                {tooltip}
              </Body>
            </Tooltip>
          </>
        }
        data={investments}
        columns={columns()}
        defaultSorted={[{ id: 'investmentUrl', desc: false }]}
        noDataText="You have no waitlist items."
      />
    </ExtendedFlex>
  );
};

WaitlistInvestmentsTable.propTypes = {
  investments: PropTypes.array,
  tooltip: PropTypes.node,
};

export default WaitlistInvestmentsTable;
